'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

AddPersonsToGroupModalController=(_class=class AddPersonsToGroupModalController extends BaseController{
static get $inject(){
return[
'$modalInstance',
'$scope',
'$timeout',
'socketService',
'group',
'organizationPersons',
'onPersonsAdded',
'uncaughtErrorHandler'];

}

constructor($modalInstance,$scope,$timeout,socketService,group,organizationPersons,onPersonsAdded,uncaughtErrorHandler){
super(uncaughtErrorHandler);
this._$modalInstance=$modalInstance;
this._$scope=$scope;
this._$timeout=$timeout;
this._onPersonsAdded=onPersonsAdded;
this._socketService=socketService;

this.group=group;

this._availablePersonsToAdd=this.filterAvailablePersons(organizationPersons,this.group.persons);

this._personsToAdd=[];
}

get availablePersonsToAdd(){
return this._availablePersonsToAdd;
}

get personsToAdd(){
return this._personsToAdd;
}

set personsToAdd(newPeopleToAdd){
this._personsToAdd=newPeopleToAdd;
}

formatPerson(person){
return _.exists(person)?`${person.firstName} ${person.lastName}`:'';
}

filterAvailablePersons(allPersons,personsToExclude){
let filteredPersons=allPersons.filter(p=>{
for(let person of personsToExclude){
if(person.id===p.id){
return!1;
}
}

return!0;
});

return filteredPersons;
}

removeFromPersonsToAdd(person){
_.remove(this._personsToAdd,person);
}


async onOk(){
await this._socketService.sendAndWaitForResponse('AddPersonsToGroup',{groupId:this.group.id,personIds:this._personsToAdd.map(p=>p.id)});
await this._onPersonsAdded(this.group.id);

this._$modalInstance.close(this);
}

onCancel(){
this._$modalInstance.dismiss();
}},(_applyDecoratedDescriptor(_class.prototype,'onOk',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'onOk'),_class.prototype)),_class);


module.exports=AddPersonsToGroupModalController;
//# sourceMappingURL=addPersonsToGroupModalController.js.map
